/**
 *
 * @param $provide
 */
export function modalProvider($provide){

  'ngInject';

  $provide.decorator('$uibModal', $delegate => {
    let open = $delegate.open;
    $delegate.open = ( options ) => {
      options = angular.extend( options || {} , {
        backdrop: 'static',
        keyboard: false
      } );
      return open(options);
    };
    return $delegate;
  } );
}


/** WEBPACK FOOTER **
 ** ./frontend/config/modalProvider.config.js
 **/